export default __webpack_public_path__ + "static/media/Manuscripts5.74126a50.png";